import Wrapper from '../components/Wrapper'
import { connect } from 'react-redux'
import firebase from '../firebaseInit'
import { intro } from '../intro'
import { login, setVocabularies, setAdvancedMode, setAccessToken, setContents, setContextsFromGist } from '../util/actions'
import { getGistList } from '../util/utils'

const db = firebase.firestore()
db.settings({timestampsInSnapshots: true})
const provider = new firebase.auth.GithubAuthProvider()
provider.addScope('gist')

const contextPaths = [
  {name: 'schema.org', header: 'schema:', url: 'https://schema.org/docs/jsonldcontext.json'},
  {name: 'OpenAnnotation', header: 'oa:', url: 'http://www.w3.org/ns/anno.jsonld'},
  {name: 'OBOFoundry', header: 'obo:', url: 'http://obofoundry.github.io/registry/context.jsonld'},
  {name: 'FOAF', header: 'foaf:', url: 'http://xmlns.com/foaf/context'},
  {name: 'IMICoreVocabulary', header: 'imicore:', url: 'https://imi.go.jp/ns/core/context.jsonld'}
]

const getVocabulary = (path) => {
  return new Promise((resolve, reject) => {
    const target = './context/' + path.name + '/context.json'
    return fetch(target).then(res => {
      if (res.ok) {
        return res.json()
      }
      throw new Error('Network response was not ok.')
    }).then(json => {
      let vocab = {...path}
      let properties = {}
      const checkProperties = []
      let types = {}
      const checkTypes = []
      // @idがあるものだけに絞り込み @で始まるものは除外
      const context = json['@context']
      Object.keys(context).forEach(key => {
        if (typeof context[key] === 'string' && context[key].indexOf('http') < 0 && !context[key].match(/^@/)) {
          if (checkProperties.indexOf(context[key]) <= 0) {
            properties[key] = context[key]
            checkProperties.push(context[key])
          }
        } else if (typeof context[key] === 'object' &&
          !((key === '@id' && context[key] === '@id') || (key === '@id' && context[key] === '@type'))
          && ((context[key].hasOwnProperty('@id') && context[key]['@id'].indexOf('http') < 0) || !context[key].hasOwnProperty('@id'))) {
          const newProperty = context[key].hasOwnProperty('@id') && !context[key]['@id'].match(/^@/) ? context[key]['@id'] : path.header.concat(key)
          if (checkProperties.indexOf(newProperty) <= 0) {
            properties[key] = newProperty
            checkProperties.push(newProperty)
          }
          if ((path.name !== 'IMICoreVocabulary' && key.match(/^[A-Z]/)) || (path.name === 'IMICoreVocabulary' && key.match(/型$/))) {
            if (checkTypes.indexOf(vocab) <= 0) {
              types[key] = properties[key]
              checkTypes.push(vocab)
            }
          }
        }
      })
      vocab['properties'] = properties
      vocab['types'] = types
      resolve(vocab)
    }).catch(error => {
      console.error('Error:', error)
      reject(error)
    })
  })
}

const mapStateToProps = (state) => ({
  user: state.user,
  inputKeys: state.mapping.inputKeys,
  showUploadModal: state.mapping.showUploadModal,
  advancedMode: state.mapping.advancedMode
})

const mapDispatchToProps = (dispatch) => ({
  loginWithGithub: (e) => {
    e.preventDefault()
    firebase.auth().signInWithPopup(provider).then(result => {
      const user = result.user
      const adInfo = result.additionalUserInfo
      dispatch(login(user.displayName, user.uid, adInfo.userName, adInfo.profile.url))
      dispatch(setAccessToken(result.credential.accessToken))
      let cache = {}
      if (window.localStorage.getItem('cache')) {
        cache = JSON.parse(window.localStorage.getItem('cache'))
      }
      cache = Object.assign(cache, {
        user: {
          cache: {
            displayName: user.displayName,
            uid: user.uid,
            userName: adInfo.userName,
            userUrl: adInfo.profile.url
          },
          expire: Date.now()
        },
      })
      window.localStorage.setItem('cache', JSON.stringify(cache))
    }).catch(error => {
      console.log(error)
    })
  },
  getGistList: async (props) => {
    if(props.user.uid){
      const List = await getGistList(props.user)
      dispatch(setContextsFromGist(List))
    }
  },
  setVocabularies: async () => {
    const promises = []
    contextPaths.forEach(path => {
      promises.push(getVocabulary(path))
    })
    let vocabularies = await Promise.all(promises)
    //すべてのTypeを検索して、valueがxsd:か、schema:で始まるものを各typeに追加
    let types = {}
    const checkTypes = []
    vocabularies.forEach(vocab => {
      Object.keys(vocab.types).forEach(key => {
        if (vocab.types[key].match(/^[xsd:]/) || vocab.types[key].match(/^[schema:]/)) {
          if (checkTypes.indexOf(vocab) <= 0) {
            types[key] = vocab.types[key]
            checkTypes.push(vocab)
          }
        }
      })
      vocabularies.forEach(vocab => {
        vocab.types = Object.assign(vocab.types, types)
      })
    })
    dispatch(setVocabularies(vocabularies))
  },
  startTutorial: (e) => {
    dispatch(setContents({
      'name': 'Manu Sporny',
      'homepage': 'http://manu.sporny.org/',
      'image': 'http://manu.sporny.org/images/manu.png'
    }))
    dispatch(setAdvancedMode(true))
    setTimeout(() => {
      document.getElementById('switchButton1').checked = true
      intro.start()
    }, 200)
  },
  handleClickAdvanced: (e) => {
    dispatch(setAdvancedMode(e.target.checked))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)



// WEBPACK FOOTER //
// ./src/containers/Wrapper.js